// extracted by mini-css-extract-plugin
module.exports = {"modalButton":"style_modalButton__0H7c0","modal":"style_modal__DzrBk","modalWrapper":"style_modalWrapper__phvV3"};